import { useState } from 'react';
import { useApp } from '../../app/lib/AppContext';

const INPUT = 'input h-11 w-full rounded-[14px] border-line text-base';
const BUTTON = 'btn h-11 rounded-[14px] border-line bg-base-100 px-4';
const inDays = (days) => new Date(Date.now() + days * 86400000).toISOString().slice(0, 10);

// Seats for a coach to gift Pro with, granted by hand until the App Store sells them. Granting seats to any account
// also turns coach mode on; ending the plan stops every gift now (the students go back to Free and are told).
export default function CoachPlanForm({ user, onSaved }) {
  const { api } = useApp();
  const coach = user.coach;
  const [values, setValues] = useState({
    seats: coach?.seats || 5, period: coach?.plan_period || 'monthly',
    period_ends_at: coach?.plan_active ? coach.plan_ends_at.slice(0, 10) : inDays(30),
  });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const set = (key) => (e) => setValues((v) => ({ ...v, [key]: e.target.value }));

  const run = async (call) => {
    setBusy(true);
    setError(null);
    try {
      await call();
      onSaved();
    } catch (e) {
      setError(e.message);
      setBusy(false);
    }
  };

  return (
    <form className="mt-2 flex flex-col gap-3 rounded-[14px] bg-base-200 p-3"
      onSubmit={(e) => { e.preventDefault(); run(() => api.put(`/admin/coaches/${user.id}/plan`, values)); }}>
      <div className="grid grid-cols-3 gap-2">
        <label className="flex flex-col gap-1"><span className="text-sm font-semibold">Số chỗ</span>
          <input type="number" min={1} className={INPUT} value={values.seats} onChange={set('seats')} required /></label>
        <label className="flex flex-col gap-1"><span className="text-sm font-semibold">Chu kỳ</span>
          <select className="select h-11 rounded-[14px] border-line" value={values.period} onChange={set('period')}>
            <option value="monthly">Tháng</option><option value="quarterly">3 tháng</option>
            <option value="half_yearly">6 tháng</option><option value="yearly">Năm</option>
          </select></label>
        <label className="flex flex-col gap-1"><span className="text-sm font-semibold">Hết hạn</span>
          <input type="date" className={INPUT} value={values.period_ends_at} onChange={set('period_ends_at')} required /></label>
      </div>
      {!coach && <p className="text-xs text-muted">Cấp chỗ cũng bật chế độ HLV cho tài khoản này.</p>}
      {error && <p role="alert" className="text-sm font-medium text-error">{error}</p>}
      <div className="flex flex-wrap gap-2">
        <button type="submit" className="btn btn-primary h-11 rounded-[14px] border-0 px-5 font-bold" disabled={busy}>{coach?.seats ? 'Lưu gói' : 'Cấp chỗ'}</button>
        {coach?.plan_active && (
          <button type="button" className={`${BUTTON} text-error`} disabled={busy}
            onClick={() => window.confirm(`Kết thúc gói của ${user.name || 'HLV này'} ngay? Mọi học viên được tặng Pro sẽ về Free.`)
              && run(() => api.del(`/admin/coaches/${user.id}/plan`))}>Kết thúc gói</button>
        )}
      </div>
    </form>
  );
}


